<template>
  <div>
    <v-dialog
      max-width="800"
      persistent
      transition="dialog-bottom-transition"
      v-model="showDialog"
    >
      <v-card :loading="loading">
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="closeDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Set to Latest Image of Showcase</v-toolbar-title>
        </v-toolbar>
        <v-card flat v-if="!listShowcases">
          <v-card-text>
            <v-alert type="warning">
              No Showcases found!
            </v-alert>
          </v-card-text>
        </v-card>
        <v-card flat v-if="listShowcases">
          <v-card-title>
            Select Source Showcase
          </v-card-title>
          <v-card-text>
            <v-select
              class="location-select"
              v-model="showcaseSelect"
              :items="listShowcases"
              label="Showcase"
            >
            </v-select>
          </v-card-text>
        </v-card>
        <v-divider></v-divider>
        <v-card flat>
          <v-card-title>
            Run Options
          </v-card-title>
          <v-card-text>
            <v-row no-gutters>
              <v-col cols="3">
                <v-radio-group v-model="scheduleOrNow" :mandatory="true">
                  <v-radio label="Run now" value="now"></v-radio>
                  <v-radio label="Schedule" value="schedule"></v-radio>
                </v-radio-group>
              </v-col>
              <v-col cols="9">
                <CloudWatchCronExpressionBuilder
                  v-model="scheduleExpression"
                  v-if="schedule"
                  show-next-events="5"
                >
                </CloudWatchCronExpressionBuilder>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <v-card-actions>
          {{ message }}
          <v-btn @click="runOperation()" :disabled="showcaseSelect === null"
            >Run</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {
  SET_TO_LATEST_IMAGE,
  SCHEDULE_SET_TO_LATEST_IMAGE,
  LIST_SHOWCASES,
  LIST_SHOWCASE_IMAGES
} from '@/domain/showcases/constants/query'
import { DOMAIN_NAME } from '@/domain/showcases'
import CloudWatchCronExpressionBuilder from '@/components/CWCronExpressionBuilder/CloudWatchCronExpressionBuilder'
import { isScheduleOnceType } from '@/domain/showcases/util/schedule'

export default {
  name: 'SetToLatestImage',
  components: {
    CloudWatchCronExpressionBuilder
  },
  data: () => ({
    showDialog: true,
    loading: false,
    scheduleOrNow: 'now',
    scheduleExpression: '',
    message: null,
    showcaseSelect: null,
    listShowcases: [],
    listShowcasesErrors: null
  }),
  props: ['showcase'],
  computed: {
    schedule: function() {
      return this.scheduleOrNow === 'schedule'
    }
  },
  methods: {
    runOperation() {
      this.message = 'Starting Operation'

      let operationHandler =
        this.scheduleOrNow === 'now'
          ? this.operationHandler
          : this.scheduleOperationHandler
      this.message = 'Starting Operation'
      operationHandler()
        .then(response => {
          this.loading = false
          this.message = 'Success!'
          this.closeDialog()
        })
        .catch(err => {
          this.loading = false
          this.message = err
        })
    },
    async operationHandler() {
      return this.$apolloProvider.clients['SHOWCASE'].mutate({
        mutation: SET_TO_LATEST_IMAGE,
        variables: {
          showcaseId: this.showcase.showcaseId,
          sourceShowcaseId: this.showcaseSelect
        },
        fetchPolicy: 'no-cache'
      })
    },
    async scheduleOperationHandler() {
      return this.$apolloProvider.clients['SHOWCASE'].mutate({
        mutation: SCHEDULE_SET_TO_LATEST_IMAGE,
        variables: {
          showcaseId: this.showcase.showcaseId,
          sourceShowcaseId: this.showcaseSelect,
          scheduleExpression: 'cron(' + this.scheduleExpression + ')',
          scheduleType: isScheduleOnceType(this.scheduleExpression)
            ? 'ONCE'
            : 'PERIODIC'
        },
        fetchPolicy: 'no-cache'
      })
    },
    closeDialog() {
      this.$emit('close')
    }
  },
  apollo: {
    $client: DOMAIN_NAME,
    listShowcases: {
      query: LIST_SHOWCASES,
      result({ data, loading, networkStatus }) {
        this.listShowcases = data.listShowcases.showcases.map(showcase => {
          return {
            text: `${showcase.name} (${showcase.showcaseId})`,
            value: showcase.showcaseId
          }
        })
      },
      error(error) {
        this.listShowcasesError = JSON.stringify(error.message)
      }
    }
  }
}
</script>

<style scoped>
.location-select {
  width: 80%;
}
</style>
